const config = {
    API_KEY: null,
    API_HOST: 'api.nextbillion.io',
    DISABLE_NB_TRANSFORM: false,
};
export default config;
//# sourceMappingURL=config.js.map